const applyStrLicenseStepsList = [
  'Property',
  'Permit Holder',
  'Parking',
  'Authorized Agent',
  'Documents',
  'Confirmation',
  'Payment',
];

const applyStrLicenseSteps = {};
applyStrLicenseStepsList.forEach((step, i) => {
  applyStrLicenseSteps[step] = i;
});

export {
  applyStrLicenseSteps,
  applyStrLicenseStepsList
}
